module.exports = "pegasus/assets/themelp1/small/8.png";